import React from 'react';
import RowItem from 'main/components/show/cuesheet.prompter/rowItem';
import Reflux from 'reflux';
import { List } from 'react-virtualized';

import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const defaultRowCount = 10;

export default React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState() {
    return {
      activeRowId: this.props.rowId,
    };
  },

  componentDidMount() {
    this.listenTo(
      FullScreenCuesheetActions.updateActiveRowInRowPanel,
      'onActiveUpdate',
    );
    this.listenTo(
      FullScreenCuesheetActions.updateTrackedRowInRowPanel,
      'onTrackedUpdate',
    );
    this.listenTo(
      FullScreenCuesheetActions.clearTrackedRowInRowPanel,
      'onClearTracked',
    );
  },

  shouldComponentUpdate(nextProps, nextState) {
    const { rowMap, rowOrder, windowHeight, itemSetId } = this.props;
    const { activeRowId, trackedRow } = this.state;

    if (
      itemSetId !== nextProps.itemSetId ||
      rowMap !== nextProps.rowMap ||
      rowOrder !== nextProps.rowOrder ||
      windowHeight !== nextProps.windowHeight ||
      activeRowId !== nextState.activeRowId ||
      trackedRow !== nextState.trackedRow
    ) {
      return true;
    }

    return false;
  },

  componentDidUpdate(prevProps) {
    const { rowMap, rowOrder } = this.props;

    if (rowMap !== prevProps.rowMap || rowOrder !== prevProps.rowOrder) {
      this._List.forceUpdateGrid();
    }
  },

  onActiveUpdate(activeRowId) {
    if (activeRowId !== this.state.activeRowId) {
      this.setState({ activeRowId });
    }
  },

  onTrackedUpdate(trackedRow) {
    if (!this.state.trackedRow || this.state.trackedRow !== trackedRow) {
      this.setState({ trackedRow, activeRowId: trackedRow.rowId });
      this._List.forceUpdateGrid();
    }
  },

  onClearTracked() {
    const { trackedRow } = this.state;
    if (trackedRow) this.setState({ trackedRow: null });
    this._List.forceUpdateGrid();
  },

  render() {
    const { activeRowId } = this.state;
    const { rowMap, rowOrder, itemSetId, width, windowHeight } = this.props;

    const rowKeys =
      rowMap && rowMap[itemSetId] ? Object.keys(rowMap[itemSetId].rows) : null;
    const rowCount = rowKeys ? rowKeys.length : defaultRowCount;
    const activeIndex = rowKeys
      ? rowOrder.findIndex((id) => id === activeRowId)
      : 0;

    const height = windowHeight - 200;

    return (
      <div id="fullscreen-rows-scroll" style={{ height }}>
        <List
          height={height}
          ref={this._setListRef}
          rowCount={rowCount}
          rowHeight={65}
          rowRenderer={this._rowRenderer}
          width={width}
          scrollToAlignment="center"
          scrollToIndex={activeIndex}
        />
      </div>
    );
  },

  _setListRef(ref) {
    this._List = ref;
  },

  _rowRenderer({ key, index, style }) {
    const { activeRowId, trackedRow } = this.state;

    const {
      columnId,
      itemSetId,
      loading,
      onRowSelect,
      rowMap,
      rowOrder,
    } = this.props;

    const rowId = rowOrder[index];

    /*
     * When you're using react-virtualized using the css nth-child(even|odd)
     * is inconsistent because the number of rows are always changing due to it
     * not rendering all the rows at one time. This causes the alternating colors
     * to get really funky on the elements. That is why we use the index.
     */
    if (index % 2 === 1) {
      style.background = '#3F3F3F';
    } else {
      style.background = '#333333';
    }

    let active = rowId === activeRowId;
    let tracked = trackedRow
      ? rowId === trackedRow.rowId && itemSetId === trackedRow.itemSetId
      : false;

    return (
      <div key={key} style={style}>
        <RowItem
          {...{
            active,
            tracked,
            index,
            rowId,
            columnId,
            itemSetId,
            loading: loading || !rowMap || !rowMap[itemSetId].rows[rowId],
            onRowSelect,
            row: loading || !rowMap ? {} : rowMap[itemSetId].rows[rowId],
            rowOrder,
          }}
        />
      </div>
    );
  },
});
